import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__six" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Вы можете скачать доверенность", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите чтобы скачать доверенность", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download_signatory && _ctx.download_signatory(...args)))
    }, "Скачать доверенность"),
    _hoisted_4,
    (_ctx.document.parent != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            style: {"width":"83px","height":"46px","position":"absolute","top":"795px","border-radius":"4px","margin-left":"756px","font-size":"14px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.go_doc && _ctx.go_doc(...args)))
          }, "Далее")
        ]))
      : _createCommentVNode("", true)
  ]))
}